'use client';

import { forwardRef, useContext } from 'react';

import { ToneIcon } from '../tone-icon';
import { ProgressStepperStepContext } from './context/progress-stepper-step.context';
import { progressStepperIconRecipe } from './styles/progress-stepper-icon.styles';
import type { ProgressStepperIconPropsInterface } from './types/progress-stepper-icon.types';

/**
 * ProgressStepper.Icon
 *
 * @since 10.0.0
 */
export const ProgressStepperIcon = forwardRef<SVGSVGElement, ProgressStepperIconPropsInterface>(
  (props: ProgressStepperIconPropsInterface, forwardedRef) => {
    const { css: cssProp, ...rest } = props;
    const { active, tone } = useContext(ProgressStepperStepContext);

    if (!tone || tone === 'none' || active) {
      return null;
    }

    return (
      <ToneIcon
        css={{ ...progressStepperIconRecipe.raw({ active, tone }), ...cssProp }}
        includeShape={false}
        tone={tone}
        ref={forwardedRef}
        {...rest}
      />
    );
  },
);

ProgressStepperIcon.displayName = 'ProgressStepper.Icon';
